<template>
  <div class="main">
    <div class="index_header">
      <div class="container">
        <div class="top">
          <img src="/assets/web/assets/menu_lc.png" class="menu_lc" @click="menuClick()">
          <div class="logo" style="height: 0.63rem;text-align: center;">
            <img src="/assets/web/assets/logob.png" style="height: 100%;">
          </div>
          <div class="right">
            <!--            <img src="/assets/web/assets/app_download.png" class="app_d" @click="jump('dp')">-->
            <img src="/assets/web/assets/psl_icon.png" class="psl_click" @click="jump('user')">
          </div>
        </div>
        <div class="header_search flex-start align-center">
          <div class="header_searchm" @click="jump('search')"></div>
          <img src="/assets/web/assets/index_search.png">
          <input type="text" placeholder="想找点什么？" v-model="search.keyword" @keyup="searchGoods">
        </div>
        <!-- header_search -->
      </div>

      <div class="menu_mask" v-if="isMenu" @click="menuClick()">
        <div class="in">
          <router-link to="/user/sell">
            <div class="icon">
              <img src="/assets/web/assets/maimai.png">
            </div>
            <p>卖号</p>
          </router-link>
        </div>
      </div>
    </div>

    <div class="index_banner">
      <!-- <swiper :options="swiperOption" ref="mySwiper" v-if="finishIn">
        <swiper-slide class="swiper-slide" v-for="(item, index) in bannerList" :key="index">

          <router-link :to="item.url">
            <img :src="item.litpic">
          </router-link>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"/>
      </swiper> -->
      <!-- <el-carousel height="150px">
        <el-carousel-item v-for="item in 4" :key="item">
          <h3 class="small">{{ item }}</h3>
        </el-carousel-item>
      </el-carousel> -->
      <el-carousel ref="slideCarousel">

        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <router-link :to="item.url">
            <img :src="item.litpic">
          </router-link>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- index_banner -->


    <div style="background-color: #ffffff;">
      <router-link to="/baopei">
        <div class="info_swiper">
          <div class="in">
            <p>
              <span v-for="(item, index) in infoList" :key="index">{{ item }}</span>
            </p>
          </div>
        </div>

      </router-link>

      <div class="index_navline">
        <div class="nav" v-for="(item, index) in navList" :key="index" @click="jump(item.href)">
          <span class="tips" :class="item.type == 'new' ? 'n' : ''" v-if="item.type">{{ item.type | typeTips }}</span>
          <div class="icon">
            <img :src="item.icon">
          </div>
          <p>{{ item.name }}</p>
        </div>
      </div>
      <!-- index_navline -->
    </div>

    <div class="index_bacc">
      <div class="left">
        <div class="l_type" @click="jump('list')">
          <span class="tips">热门</span>
          <div class="icon">
            <img src="/assets/web/assets/wymh_icon.png">
          </div>
          <p class="t">我要买号</p>
          <p class="i" style="color: #d3a675;">梦幻西游手游</p>
        </div>
<!--        <div class="l_type" @click="jump('list?gameid=689')">-->
<!--          <span class="tips">热门</span>-->
<!--          <div class="icon">-->
<!--            <img src="/assets/web/assets/newmh3d.png">-->
<!--          </div>-->
<!--          <p class="t">我要买号</p>-->
<!--          <p class="i" style="color: #42ccf3;">梦幻西游三维版</p>-->
<!--        </div>-->
      </div>
        <div class="right">
            <a class="bacc2_btn" @click="jump('recycling')">
                <img src="/assets/web/assets/bacc2_icon1.png?v=310">
                <span>高价回收</span>
            </a>
            <a class="bacc2_btn" @click="jump('zhaohao')">
                <img src="/assets/web/assets/bacc2_icon2.png?v=310">
                <span>免费找号</span>
            </a>
            <a class="bacc2_btn" @click="jump('https://www.douyin.com/user/MS4wLjABAAAAm2KNhWmW2gDXUv9jgI71KjTVcsJsgqCbofO5-wKTt_Y?from_tab_name=main')">
                <img src="/assets/web/assets/bacc2_icon3.png?v=310">
                <span>直播估价</span>
            </a>
        </div>
      <div class="right">
        <a class="bacc_btn" @click="jump('fenqi')">
          <img src="/assets/web/assets/bacc_icon1.png">
          <span>分期购号</span>
        </a>
        <a class="bacc_btn" @click="jump('zhongjie')">
          <img src="/assets/web/assets/bacc_icon2.png">
          <span>约定交易</span>
        </a>
        <a class="bacc_btn" @click="jump('baopei')">
          <img src="/assets/web/assets/bacc_icon3.png">
          <span>找回包赔</span>
        </a>
      </div>
    </div>
    <!-- index_bacc -->

    <div class="index_recent">
      <div class="recent_line">
        <img src="/assets/web/assets/recent_icon1b.png" class="icon">
        <div class="r">
          <p class="f13 col333">{{ web_config.jjy3 ? web_config.jjy3[0] : '-' }}</p>
          <swiper :options="recentOne">
            <swiper-slide class="swiper-slide" v-for="(item, index) in web_config.jjy" :key="index">
              <span>{{ item }}</span>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="recent_line">
        <img src="/assets/web/assets/recent_icon2b.png" class="icon">
        <div class="r">
          <p>{{ web_config.jjy4 ? web_config.jjy4[0] : '' }}</p>
          <swiper :options="recentTwo">
            <swiper-slide class="swiper-slide" v-for="(item, index) in web_config.jjy2" :key="index">
              <span>{{ item }}</span>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <!-- index_recent -->

    <div class="index_gamebox">
      <div class="top">
        <span class="btn" :class="gameOn == index ? 'on' : ''" v-for="(item, index) in gameClass" :key="index"
              @click="gameClick(index)">{{ item.title }}</span>
      </div>
      <div class="search">
        <input type="text" v-model="gameKeyword" @keyup="searchGame" placeholder="请输入游戏名">
        <button @click="searchGame" class="searchbtn"></button>
      </div>
      <div class="content">
        <swiper :options="gameSwiper">
          <swiper-slide class="swiper-slide game_type" v-for="(item, index) in gameList" :key="index">

            <router-link :to="'/list?gameid='+item.id">

              <div class="img">
                <img :src="item.litpic">
              </div>
              <p class="title">{{ item.name }}</p>

            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <!-- index_gamebox -->

    <div class="index_checkline">

      <div class="check_line">
        <input type="text" v-model="checkServerInfo" placeholder="请输入客服微信号">
        <button @click="checkServer">验收客服微信</button>
      </div>
      <div class="check_line">
        <input type="text" v-model="checkBankIdInfo" placeholder="请输入收款账号">
        <button @click="checkBankId">验收收款账号</button>
      </div>
    </div>
    <!-- index_checkline -->

    <div class="index_newsbox">
      <div class="top">
        <span class="t">资讯公告</span>
        <router-link to="/news" class="more flex-start align-center">
          <span>更多</span>&nbsp;
          <img src="/assets/web/assets/icon2.png" alt="">
        </router-link>
      </div>

      <div class="container">
        <a class="type" v-for="(item, index) in newsList" :key="index" @click="jump(item.href)">
          <span class="c">[{{ item.category.name }}]</span>
          <span class="t">{{ item.name }}</span>
          <span class="d">{{ item.createdAt }}</span>
        </a>
      </div>
    </div>
    <!-- index_newsbox -->

    <div class="index_bottomline flex-center align-center">
      <router-link class="a" to="/aciden">
        <img src="/assets/web/assets/ib_icon1.png">
        <span>真假客服鉴定</span>
      </router-link>
      <div class="a" @click="showService()">
        <img src="/assets/web/assets/ib_icon2.png">
        <span>在线咨询</span>
      </div>
      <router-link class="a" to="fenqi">
        <img src="/assets/web/assets/ib_icon3.png">
        <span>分期计算器</span>
      </router-link>
    </div>
    <!-- index_bottomline -->

    <a class="index_telline" href="tel:18989545463">
      <img src="/assets/web/assets/kfrx_icon.png">
      <span>客服热线：<i>18989545463</i></span>
    </a>

    <div class="index_footer">
      <div class="navline">
        <ul>
          <li>
            <router-link to="jianjie">关于弥亚猪</router-link>
          </li>
          <li>
            <router-link to="stm5">扫黑除恶</router-link>
          </li>
          <li>
            <a @click="showService()">意见反馈</a>
          </li>
        </ul>
      </div>
      <div class="content">
        <p>弥亚猪24个小时为您提供安全快捷的服务</p>
        <p><a href="https://beian.miit.gov.cn" target="_blank">浙ICP备18024664号</a></p>
        <p>诸暨市弥亚信息技术有限公司</p>
        <p>浙网文（2018）8897-715号</p>
        <p>增值电信业务经营许可证：浙B2-20181288</p>
        <p>miyazhu.com版权所有</p>
		<div style="width:300px;margin:0 auto; padding:0 0 0.1rem;">
		     <a target="_blank" href="https://beian.miit.gov.cn" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="/assets/web/assets/beian.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#ccc;">浙公网安备 33068102000897号</p></a>
		</div>
      </div>
      <div class="imgline">
        <img src="/assets/web/assets/ifooter_img1.png">
        <img src="/assets/web/assets/ifooter_img2.png">
        <img src="/assets/web/assets/ifooter_img3.png">
      </div>
    </div>

    <div class="tcbg" :style="{display:service?'block':'none'}"></div>
    <div class="tckf" onselectstart="return false;" :style="{display:service?'block':'none'}"
         style="background: url(/assets/web/assets/icon16.png) no-repeat center top; background-size: 100% auto;">

      <div class="tckfbox">

        <div class="kftop flex-column align-center"><span class="f18 b">人工客服</span></div>
        <span class="kfclose" @click="showService()"></span>
        <kf/>
      </div>
    </div><!--tckf end-->
    <!-- <div onselectstart="return false;" class="tckf" :style="{display:service?'block':'none'}"><div class="tckfbox">
      <div class="kftop flex-column align-center"><span class="f18 b">人工客服</span></div>
      <kf/>
       <div class="tc_bottom"
           style="margin-top: 23px; user-select: none; padding-bottom: 20px; height: 32px; line-height: 32px;">
        <span class="tc_bottom_img" @click="showService()">关闭</span>
      </div>
    </div></div> -->

  </div>
</template>

<script>
import {
  swiper,
  swiperSlide,
} from 'vue-awesome-swiper'
import Kf from './kf'

export default {
  components: {
    Kf,
    swiper,
    swiperSlide,
  },
  computed:   {
    web_config() {
      return this.$store.state.web.web_config
    },
  },
  data() {
    return {
      loadFinish:      false,
      checkBankIdInfo: '',
      checkServerInfo: '',
      bannerList:      [],
      swiperOption:    {
        loop:     true,
        autoplay: {
          delay:                3000,
          stopOnLastSlide:      false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el:        '.swiper-pagination',
          clickable: true, //允许分页点击跳转
        },
        on:         {

          click(e) {
            // 使用e.target事件代理获取点击的元素，通过data语法获取元素的属性值
            let url = e.target.dataset.itemurl
            // 这里的this指向轮播,所以我在外边声明了_this用来代表vue实例
            this.jump(url) // 跳转到详情页
          },
        },

      },
      recentOne:       {
        loop:           true,
        direction:      'vertical',
        allowTouchMove: false,
        autoplay:       {
          delay:                3000,
          stopOnLastSlide:      false,
          disableOnInteraction: false,
        },
      },

      recentTwo:  {
        loop:           true,
        direction:      'vertical',
        allowTouchMove: false,
        autoplay:       {
          delay:                3000,
          stopOnLastSlide:      false,
          disableOnInteraction: false,
        },
      },
      search:     {
        keyword: '',
      },
      gameSwiper: {
        freeMode:      true,
        slidesPerView: 4,
      },
      finishIn:   false,
      infoList:   [
        '弥亚猪平台购买任何账号全部找回包赔 找回包赔终身有效 找回包赔无需买家支付额外费用 免费包赔 活动永久有效',
        '弥亚猪平台购买任何账号全部找回包赔 找回包赔终身有效 找回包赔无需买家支付额外费用 免费包赔 活动永久有效',
        '弥亚猪平台购买任何账号全部找回包赔 找回包赔终身有效 找回包赔无需买家支付额外费用 免费包赔 活动永久有效',
        '弥亚猪平台购买任何账号全部找回包赔 找回包赔终身有效 找回包赔无需买家支付额外费用 免费包赔 活动永久有效',
        '弥亚猪平台购买任何账号全部找回包赔 找回包赔终身有效 找回包赔无需买家支付额外费用 免费包赔 活动永久有效',
        '弥亚猪平台购买任何账号全部找回包赔 找回包赔终身有效 找回包赔无需买家支付额外费用 免费包赔 活动永久有效',
        '弥亚猪平台购买任何账号全部找回包赔 找回包赔终身有效 找回包赔无需买家支付额外费用 免费包赔 活动永久有效',
      ],
      navList:    [{
        icon: '/assets/web/assets/index_nav1.png',
        name: '我要卖号',
        type: 'hot',
        href: '/jszh',
      },
        {
          icon: '/assets/web/assets/index_nav2.png',
          name: '游戏代练',
          type: '',
          href: 'dl',
        },
        {
          icon: '/assets/web/assets/index_nav3.png',
          name: '账号回收',
          type: 'high',
          href: 'recycling',
        },
        {
          icon: '/assets/web/assets/index_nav4.png',
          name: '免费估号',
          type: 'hot',
          href: 'est',
        },
        {
          icon: '/assets/web/assets/index_nav5.png',
          name: '找号服务',
          type: 'new',
          href: 'zhaohao',
        },
        {
          icon: '/assets/web/assets/index_nav6.png',
          name: '分期购号',
          type: '',
          href: 'fenqi',
        },
        {
          icon: '/assets/web/assets/index_nav7.png',
          name: '约定交易',
          type: '',
          href: 'zhongjie',
        },
        {
          icon: '/assets/web/assets/index_nav8.png',
          name: '找回包赔',
          type: '',
          href: 'baopei',
        },
        {
          icon: '/assets/web/assets/index_nav9.png',
          name: '代秒公示',
          type: '',
          href: 'gsq',
        },
        // {
        //   icon: '/assets/web/assets/index_nav10.png',
        //   name: '苹果充值',
        //   type: '',
        //   href: 'chongzhi',
        // },
        // {
        //   icon: '/assets/web/assets/index_nav11.png',
        //   name: 'APP下载',
        //   type: '',
        //   href: 'dp',
        // },
        {
          icon: '/assets/web/assets/index_nav12.png',
          name: '金币专区',
          type: '',
          href: '/list?meng9617=金币专区',
        },
        {
          icon: '/assets/web/assets/index_nav13.png',
          name: '转区查询',
          type: '',
          href: 'https://my.163.com/zfcx/',
        },
        {
          icon: '/assets/web/assets/index_nav14.png',
          name: '跨服大区',
          type: '',
          href: 'kuafu',
        },
        {
          icon: '/assets/web/assets/index_nav15.png',
          name: '游戏攻略',
          type: '',
          href: 'strategy',
        },
        // {
        //   icon: '/assets/main/zh.jpg',
        //   name: '存号转租',
        //   type: '',
        //   href: 'chzz',
        // },
      ],

      gameClass:   [
        {title: '热门游戏'},
        {title: 'A'},
        {title: 'B'},
        {title: 'C'},
        {title: 'D'},
        {title: 'E'},
        {title: 'F'},
        {title: 'G'},
        {title: 'H'},
        {title: 'I'},
        {title: 'J'},
        {title: 'K'},
        {title: 'L'},
        {title: 'M'},
        {title: 'N'},
        {title: 'O'},
        {title: 'P'},
        {title: 'Q'},
        {title: 'R'},
        {title: 'S'},
        {title: 'T'},
        {title: 'U'},
        {title: 'V'},
        {title: 'W'},
        {title: 'X'},
        {title: 'Y'},
        {title: 'Z'},
      ],
      gameOn:      0,
      gameList:    [],
      newsList:    [{
        'category':  {'name': '公告'},
        'name':      '打击网络谣言，我们在行动',
        'createdAt': '2024-10-19',
        'href':      'stm1',
      },{
        'category':  {'name': '公告'},
        'name':      '关于不向未成年人提供交易服务的声明',
        'createdAt': '2021-09-13',
        'href':      'stm6',
      }, {
        'category':  {'name': '公告'},
        'name':      '致广大玩家的一封信',
        'createdAt': '2021-07-23',
        'href':      'stm5',
      }, {
        'category':  {'name': '公告'},
        'name':      '弥亚平台简介',
        'createdAt': '2020-10-15',
        'href':      'jianjie',
      }, {
        'category':  {'name': '公告'},
        'name':      '弥亚猪对恶意抹黑行为的重要声明',
        'createdAt': '2020-05-20',
        'href':      'stm',
      }, {
        'category':  {'name': '资讯'},
        'name':      '弥亚猪找回包赔案例',
        'createdAt': '2020-05-18',
        'href':      'stm2',
      }, {
        'category':  {'name': '资讯'},
        'name':      '多个找回者被判有期徒刑',
        'createdAt': '2020-05-18',
        'href':      'stm3',
      }, {
        'category':  {'name': '资讯'},
        'name':      '弥亚猪诉讼案例',
        'createdAt': '2020-05-17',
        'href':      'stm4',
      }],
      isMenu:      false,
      gameKeyword: '',
      service:     false,
    }
  },
  async mounted() {
    //轮播
    this.slideBanner()
    let self = this

    //var loadings = this.$loading({fullscreen: true})

    // let results     = await this.$request('/api/web/ads/', {data: {id: 10}})
    this.bannerList = [{
      'id':       131,
      'aid':      10,
      'ads_name': '找回包赔',
      'url':      '/baopei',
      'litpic':   '/assets/web/assets/20210617214304_240.jpg',
      'orders':   0,
      'ext':      '',
    }, {
      'id':       132,
      'aid':      10,
      'ads_name': '约定中介',
      'url':      '/zhongjie',
      'litpic':   '/assets/web/assets/20210617214332_437.jpg',
      'orders':   0,
      'ext':      '',
    }]
    // //console.log(this.bannerList)


    self.finishIn = true


    this.getGameList()

    let results = await this.$request('/api/web/news/')
    this.$store.commit('web/SET_WEB_TITLE', '诸暨市弥亚信息技术有限公司')


    // this.newsList = results.data;

    // this.$store.commit('web/SET_WEB_TITLE', '')

    // setTimeout(function () {
    //   loadings.close()
    //   self.loadFinish = true
    // }, 300)
  },
  filters: {
    typeTips(tips) {
      switch (tips) {
        case 'hot':
          return '热门'
        case 'high':
          return '高价'
        case 'new':
          return '最新'
        default:
          return ''
      }
    },
  },
  methods: {
    //轮播
    // 滑动 切换
    slideBanner() {
      //选中的轮播图
      var box        = document.querySelector('.el-carousel__container')
      var startPoint = 0
      var stopPoint  = 0
      //重置坐标
      var resetPoint = function () {
        startPoint = 0
        stopPoint  = 0
      }
      //手指按下
      box.addEventListener('touchstart', function (e) {
        //手指点击位置的X坐标
        startPoint = e.changedTouches[0].pageX
      })
      //手指滑动
      box.addEventListener('touchmove', function (e) {
        //手指滑动后终点位置X的坐标
        stopPoint = e.changedTouches[0].pageX
      })
      //当手指抬起的时候，判断图片滚动离左右的距离
      let that = this
      box.addEventListener('touchend', function (e) {
        //console.log('1：' + startPoint)
        //console.log('2：' + stopPoint)
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint()
          return
        }
        if (startPoint - stopPoint > 0) {
          resetPoint()
          that.$refs.slideCarousel.next()
          return
        }
        if (startPoint - stopPoint < 0) {
          resetPoint()
          that.$refs.slideCarousel.prev()
          return
        }
      })
    },

    showService() {
      this.service = !this.service
    },
    menuClick() {
      this.isMenu = !this.isMenu
    },
    searchGoods(event) {

      if (event.keyCode == 13) { //如果按的是enter键 13是enter
        event.preventDefault() //禁止默认事件（默认是换行）

        this.$router.push('list?keyword=' + this.search.keyword)
      }

    },
    searchGame(event) {
      if (event.keyCode == 13 || event.type == 'click') { //如果按的是enter键 13是enter

        event.preventDefault() //禁止默认事件（默认是换行）

        if (this.gameKeyword == '') {
          return this.mui.toast('请输入游戏名')
        }

        this.getGameList(0)
      }

    },
    gameClick(index) {
      this.gameOn = index
      this.getGameList(index > 0 ? this.gameClass[index].title : '')

    },
    async checkServer() {
      let results = await this.$request('/api/web/checkServer/', {data: {value: this.checkServerInfo}})

      this.mui.toast(results.msg)
    },
    async checkBankId() {
      let results = await this.$request('/api/web/checkBankId/', {data: {value: this.checkBankIdInfo}})

      this.mui.toast(results.msg)
    },
    jump(href) {
      if (href.indexOf('http') != -1) {
        window.location.href = href
      } else {
        this.$router.push(href)
      }

    },
    async getGameList(f = '') {

      let results = await this.$request('/api/web/gameList', {data: {f, keyword: this.gameKeyword}})

      this.gameList = results.data
    },
  },
}
</script>

<style lang="less" scoped>
.header_search {
  position: relative;
}

.header_searchm {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 100;
}

.search {
  position: relative;
}

.searchbtn {
  position: absolute;
  top: 0;
  right: 0;
  width: 15%;
  height: 0.62rem;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: none !important;
  z-index: 9;
}

.info_swiper .in p {
  font-size: 0.2rem;
  color: #fb6f60;
}

.index_navline {
  padding: 0.15rem 0.15rem 0.2rem;
}

.index_navline .nav {
  margin-bottom: 0;
}

.index_navline .nav p {
  margin: 0;
}

.index_bacc .l_type .i {
  margin-bottom: 0;
}

.index_newsbox .top .more img {
  margin-top: -0.04rem;
}

.index_newsbox .container {
  padding: 0 0.22rem 0.25rem;
}

.index_newsbox .type {
  height: auto;
  margin-top: 0.25rem;
  line-height: initial;
}

.index_newsbox {
  padding-top: 0;
}

.index_newsbox .type::before {
  opacity: 0;
}

.index_newsbox .top::after {
  background: #e5e5e5;
}

.index_telline i {
  color: #ffa303;
}

.index_footer {
  padding: 0.25rem 0;
}

.index_footer .navline {
  margin-bottom: 0.1rem;
}

.index_footer .navline a {
  font-size: 0.22rem;
  line-height: 0.4rem;
}

.index_footer .navline li::before {
  width: 1px;
}

.index_footer .content {
  margin: 0;
}

.index_footer .content p {
  color: #ccc;
  font-size: 0.22rem;
  margin-bottom: 0;
  line-height: 0.3rem;
  padding-bottom: 0.1rem;
}

.index_footer .imgline {
  margin: 0;
}

.index_footer .imgline img {
  height: 0.5rem;
  margin: 0 0.05rem;
  width: auto;
}

/* .main {
  background-color: #ffffff;
} */

a {
  text-decoration: none;
}

.menu_mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9;

  .in {
    position: absolute;
    top: 1.1rem;
    left: 0.2rem;
    width: 7.1rem;
    border-radius: 0.1rem;
    padding: 0.3rem 0;
    background: #ffffff;
    font-size: 0;
    z-index: 11;

    &::before {
      content: "";
      position: absolute;
      left: 0.28rem;
      top: -0.21rem;
      border-right: 0.15rem solid transparent;
      border-left: 0.15rem solid transparent;
      border-bottom: 0.22rem solid #fff;
      position: absolute;
    }
  }

  a {
    display: inline-block;
    width: 33%;
    text-align: center;
  }

  .icon {
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 0.8rem;
    height: 0.8rem;
    border-radius: 0.15rem;
    background: linear-gradient(135deg, #ffa315, #f50);

    img {
      width: 0.48rem;
    }
  }

  p {
    margin-top: 0.03rem;
    font-size: 0.26rem;
    color: #333333;
  }
}

.game_type .title {
  color: #333333;
}

.index_banner {
  height: 4rem;
}

.index_navline .nav .icon {
  margin: auto;
  height: 0.8rem;
}

.index_navline .nav .icon img {
  width: 100%;
}

.index_banner .swiper-slide img {
  width: 100% !important;
}
</style>
